<template>
  <v-container class="containerStyle" style="place-content: center">
    <template style="place-content: center">
      <div class="container">
        <div class="login">
          <div class="content">
            <img class="login-left-img" :src="sideImg" alt="Login Logo" />
          </div>
          <div class="loginForm">
            <!-- <v-flex class="preLoginHeaderstyle" id="createAccount">
                    <b><label style="font-family: Arial;">LOGIN</label></b><br><br>
                </v-flex> -->
            <h1>Login</h1>

            <label class="tbox">
              <b><h3 dir="auto" style="font-size: inherit">Username</h3></b>
            </label>
            <v-text-field
              class="mt-2 mb-0"
              :autocomplete="'off'"
              type="tel"
              inputmode="numeric"
              transition="slide-x-transition"
              id=""
              label="Username"
              solo
              v-model="username"
              maxLength="5"
              v-on:keypress="isNumber($event)"
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);this.value = this.value.replace(/[^0-9]/gi, '');"
            >
            </v-text-field>

            <div
              style="color: red; text-align: left; padding-bottom: 2px"
              v-if="usernameError.length > 0"
            >
              {{ usernameError }}
            </div>

            <label class="tbox">
              <b><h3 dir="auto" style="font-size: inherit">Password</h3></b>
            </label>
            <!-- <v-text-field class="mt-2 mb-0 tooltip" transition="slide-x-transition" label="Password" type="password" name="password" solo v-model="password" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'" :type="showPassword ? 'text' : 'password'" @click:append="showPassword = !showPassword">
                    <i class="fas" :class="{ 'fa-eye-slash': showPassword, 'fa-eye': !showPassword }"></i>
                </v-text-field> -->

            <v-text-field
              :autocomplete="'off'"
              class="mt-2 mb-0 tooltip"
              transition="slide-x-transition"
              label="Password"
              name="password"
              :type="showPwd ? 'text' : 'password'"
              solo
              v-model="password"
              maxLength="20"
              oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
            >
              <template v-slot:append>
                <a @click="pwdShowHide()" v-show="!showPwd" v-hide="showPwd"
                  ><img width="24" :src="hidePwdIco" height="24"
                /></a>
                <a @click="pwdShowHide()" v-show="showPwd" v-hide="!showPwd"
                  ><img width="24" :src="showPwdIco" height="24"
                /></a>
              </template>

              <!-- <div class="input-group-append">
          <span class="input-group-text"><i class="fa fa-eye-slash" aria-hidden="true"></i></span>
        </div> -->
            </v-text-field>

            <div
              style="color: red; text-align: left"
              v-if="pwdErrormsg.length > 0"
            >
              {{ pwdErrormsg }}
            </div>
            <div class="d-flex" style="text-align: right; margin-bottom: 5px">
              <b
                ><a
                  v-on:click="
                    PreLoader = true;
                    forgotPwd_click();
                  "
                  style="color: black !important; font-size: inherit"
                  >Forgot password?</a
                ></b
              >
            </div>

            <v-flex xs12 sm12 md12>
              <v-layout>
                <v-flex xs12 sm12 md6>
                  <v-btn
                    color="primary-btn"
                    style="font-size: 18px"
                    dark
                    block
                    class="text-none"
                    v-on:click="
                      PreLoader = true;
                      login_button_click();
                    "
                    >Login</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-flex>
          </div>
        </div>
      </div>

      <!-- Change Password pop up -->
      <v-card
        class="modal-backdrop cards procDiv container hide"
        ref="modal"
        id="loginModal"
        data-keyboard="false"
        data-backdrop="static"
        v-show="isModalpopUp"
        style="inset-inline: auto !important"
      >
        <!-- Change password pop up  -->
        <div
          class="modal"
          style="
            overflow-y: auto;
            border-radius: 15px;
            padding: 5px;
            width: 40%;
            height: max-content;
            border-radius: 15px;
            padding: 5px;
          "
          v-show="changePasswordPopup && (!errorPopup || !userNameVerifyPopUp)"
        >
          <div class="facingPage">
            <h4
              class="grey--text text--darken-2 mb-0 mt-1"
              style="
                text-align: center;
                padding-bottom: 5%;
                color: #ff8200 !important;
                border-bottom: 1px solid lightgrey;
              "
            >
              Change Password
            </h4>
            <p
              class="grey--text text--darken-2 mb-0 mt-1"
              id="proc_message"
              style="
                text-align: center;
                padding-bottom: 5%;
                color: black !important;
                padding-top: 10px;
              "
            >
              Click on the continue button to change your current password
            </p>
            <v-flex
              style="border-top: none !important; align-self: center"
              class="text-align-center padding-bottom-5"
            >
              <v-layout class="text-align-center padding-bottom-5">
                <v-flex
                  class="text-align-center padding-bottom-5"
                  style="display: -webkit-inline-box; -webkit-box-pack: center"
                >
                  <v-btn
                    class="text-align-center padding-bottom-5 text-none"
                    color="primary-btn"
                    @click="ContinueToChangePwd()"
                    dark
                    block
                    >Continue</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-flex>
          </div>
        </div>

        <!-- Error pop up  -->
        <div
          class="modal"
          style="
            overflow-y: auto;
            border-radius: 15px;
            padding: 5px;
            width: 40%;
            height: max-content;
            border-radius: 15px;
            padding: 5px;
          "
          v-show="errorPopup && (!changePasswordPopup || !userNameVerifyPopUp)"
        >
          <div class="facingPage">
            <h4
              class="grey--text text--darken-2 mb-0 mt-1"
              style="
                text-align: center;
                padding-bottom: 5%;
                color: #ff8200 !important;
                border-bottom: 1px solid lightgrey;
              "
            >
              Alert!
            </h4>
            <p
              class="grey--text text--darken-2 mb-0 mt-1"
              id="proc_message"
              style="
                text-align: center;
                padding-bottom: 5%;
                color: black !important;
                padding-top: 10px;
              "
            >
              {{ dsaLoginErrorMsg }}
            </p>
            <v-flex
              style="border-top: none !important; align-self: center"
              class="text-align-center padding-bottom-5"
            >
              <v-layout class="text-align-center padding-bottom-5">
                <v-flex
                  class="text-align-center padding-bottom-5"
                  style="display: -webkit-inline-box; -webkit-box-pack: center"
                >
                  <v-btn
                    class="text-align-center padding-bottom-5 text-none"
                    color="primary-btn"
                    @click="returnToLoginPage()"
                    dark
                    block
                    >OK</v-btn
                  >
                </v-flex>
              </v-layout>
            </v-flex>
          </div>
        </div>

        <!-- Forgot password Pop Up -->
        <!-- <div class="modal" style=" overflow-y: auto; border-radius: 15px; padding: 5px; width: 35%;height: max-content; border-radius: 15px;padding: 5px;" v-show="userNameVerifyPopUp" v-hide="changePasswordPopup || userNameVerifyPopUp">
    
      <div class="facingPage">
                  <h4 class="grey--text text--darken-2 mb-0 mt-1" style="text-align: center; padding-bottom: 5%;color: #FF8200 !important; border-bottom: 1px solid #80808052;" >Forgot Password</h4>
  
              <div style="margin-top: 1rem; margin-bottom: 1rem;">
                  <label for="verifyUserName">
                      <h3>Username</h3>
                  </label>
                  <p style="margin-bottom: 1rem;"> You will receive a 6 digit code to the registered mail for verification</p>
                  
                  <v-text-field  class="UNStyle" transition="slide-x-transition" id="" solo v-model="verifyUserName" name="verifyUserName" label="Enter Username" maxlength="5" type="tel" inputmode="numeric" v-on:keypress="isNumber($event)" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);this.value = this.value.replace(/[^0-9]/gi, '');"></v-text-field>
                  <div style="color:red;text-align: left;padding-bottom: 2px;" v-if="verifyUserNameErrMsg.length > 0">{{verifyUserNameErrMsg}}</div> 
              </div>
                  <v-flex style="border-top: none !important; align-self: center;" class="text-align-center padding-bottom-5" >
                      <v-layout class="text-align-center padding-bottom-5" >
                          <v-flex class="text-align-center padding-bottom-5" style="display: -webkit-inline-box; -webkit-box-pack: center;">
                              <v-btn class="text-align-center padding-bottom-5 text-none" color="primary-btn" v-on:click="PreLoader=false;continueToOtpPage()" dark block >Continue</v-btn>
                          </v-flex>
                      </v-layout>
                  </v-flex>
              </div>
  </div> -->

        <!-- </v-card> -->
      </v-card>
    </template>
    <!--Preloader starts-->
    <div
      class="pre-loader"
      v-show="PreLoader == true"
      v-hide="PreLoader == false"
    >
      <img :src="preLoaderImg" />
    </div>

    <!--Preloader ends-->
  </v-container>
</template>

<script>
import { db, externalURL } from "@/sunidhiapp";
// import config from '@/sunidhiapp';
// import jQuery from 'jquery';
import router from "@/router";
import axios from "axios";
import sideImgSrc from "@/assets/images/AccessLoginLogo.svg";
import loader from "@/assets/images/Preloader.gif";
import hidePwdImgSrc from "@/assets/images/eye hide.svg";
import showPwdImgSrc from "@/assets/images/eye view.svg";
import { setSessionId } from '@/services/sessionservice';
export default {
  name: "LoginPage",

  data: function () {
    return {
      username: "",
      usernameErrormsg: "",
      usernameError: "",
      password: "",
      pwdErrormsg: "",
      changePasswordPopup: false,
      isModalpopUp: false,
      errorPopup: false,
      PreLoader: true,
      dsaLoginErrorMsg: "",
      showPassword: false,
      showPwd: false,
      userNameVerifyPopUp: false,
      forgotPwdUsername: "",
      forgotPwdUserErrorMsg: "",
      verifyUserName: "",
      sideImg: sideImgSrc,
      preLoaderImg: loader,
      hidePwdIco: hidePwdImgSrc,
      showPwdIco: showPwdImgSrc,
      // logoSrc: require('@/assets/images/AccessLoginLogo.svg')
    };
  },
  // computed: {
  //     config() {
  //         return config;
  //     }
  // },
  mounted: async function () {
    sessionStorage.removeItem('DUPLICATE_SESSION_HANDLED')
    await this.$sunidhi.checkDBVersion();
    this.devicecheck();
    this.getLocation();
    // setLogoutBtnDisp('true');
    this.$sunidhi.logoutBtnDisp = false;
  },
  methods: {
    pwdShowHide() {
      this.showPwd = !this.showPwd;
    },
    limitInput(event) {
      if (event.target.value.length > this.maxLength) {
        event.target.value = event.target.value.slice(0, this.maxLength);
      }
    },
    handleInput(event) {
      // Ensure max length is enforced
      if (event.target.value.length > event.target.maxLength) {
        event.target.value = event.target.value.slice(
          0,
          event.target.maxLength
        );
      }
      // Remove non-numeric characters
      event.target.value = event.target.value.replace(/[^0-9]/g, "");
      this.username = event.target.value;
    },
    handlePwdInput(event) {
      if (event.target.value.length > event.target.maxLength) {
        event.target.value = event.target.value.slice(
          0,
          event.target.maxLength
        );
      }
      this.password = event.target.value;
    },
    validateUsername() {
      if (!this.username) {
        this.usernameError = "Username is required.";
      } else {
        this.usernameError = "";
      }
    },
    validatePwd() {
      if (!this.password) {
        this.pwdErrormsg = "Password is required.";
      } else {
        this.pwdErrormsg = "";
      }
    },

    // async pwdShowHide() {
    //     // debugger
    //     var self = this;

    //     self.showPwd = !self.showPwd;
    // },
    async pwdCheck() {
      const togglePassword = document.querySelector("#togglePassword");
      const password = document.querySelector("#id_password");

      togglePassword.addEventListener("click", function () {
        // toggle the type attribute
        const type =
          password.getAttribute("type") === "password" ? "text" : "password";
        password.setAttribute("type", type);
        // toggle the eye slash icon
        this.classList.toggle("fa-eye-slash");
      });
    },

    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 43
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },

    devicecheck() {
      var deviceAgent = navigator.userAgent.toLowerCase();
      var agentID = deviceAgent.match(/(iphone|ipod|ipad)/);
      if (agentID) {
        var safari = deviceAgent.match(/(version)/);
        var ios = deviceAgent.match(/([1-9][2-9]_[0-9]_?)/);
        if (!safari || !ios) {
          // router.push({ name: "unsupported" });
        }
      }
    },
    getLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(this.showPosition);
        setTimeout(() => {
          this.PreLoader = false;
        }, 500);
      } else {
        console.log("Geolocation is not supported by this browser.");
      }
    },
    showPosition(position) {
      // Access latitude and longitude from the position object
      const latitude = position.coords.latitude;
      const longitude = position.coords.longitude;

      // Do something with latitude and longitude, for example, update state
      this.latitude = latitude;
      this.longitude = longitude;

      // You can also perform any other necessary actions here
      console.log("Latitude: " + latitude + ", Longitude: " + longitude);
    },

    async continueToOtpPage() {
      var self = this;
      self.PreLoader = true;
      var vaerror = 0;

      // if (self.verifyUserName.length <= 0) {
      //     config.verifyUserNameErrMsg = " Enter the Username"
      //     vaerror = 1;
      // }

      if (vaerror == 1) {
        setTimeout(() => {
          self.PreLoader = false;
        }, 500);

        return;
      } else {
        var object = new Object();
        object.verifyUserName = self.verifyUserName;
        var genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
        if (genzdata != null && genzdata.length > 0) {
          await db.TbGenz.update(genzdata[0].PkId, {
            LoginUserID: object.verifyUserName,
          });
        } else {
          await db.TbGenz.put({
            UserId: 1,
            LoginUserID: object.verifyUserName,
          });
          genzdata = await db.TbGenz.where("UserId").anyOf(1).toArray();
        }

        await this.ValidatePWADSALoginId(object.verifyUserName, self.PreLoader);
      }
    },

    async forgotPwd_click() {
      // debugger
      var self = this;
      self.PreLoader = true;
      document.getElementById("loginModal").style.display = "";
      self.isModalpopUp = true;
      self.changePasswordPopup = false;
      self.errorPopup = false;
      self.userNameVerifyPopUp = true;
      this.logoutBtnDisp = "false";
      this.$router.replace({ name: "ForgotPassword" });
      setTimeout(() => {
        self.PreLoader = false;
      }, 500);
    },
    async login_button_click() {
      var self = this;
      self.PreLoader = true;
      // self.usernameErrormsg = "";
      // self.pwdErrormsg = "";
      self.dsaLoginErrorMsg = "";
      self.errorPopup = false;

      var vaerror = 0;
      // if (self.username.length <= 0) {
      //     self.usernameErrormsg = "Enter Username";
      //     vaerror = 1;
      // }
      self.validateUsername();
      self.validatePwd();
      if (self.usernameError != "") {
        vaerror = 1;
      }
      if (self.pwdErrormsg != "") {
        vaerror = 1;
      }
      // if (self.password.length <= 0) {
      //     self.pwdErrormsg = "Enter password";
      //     vaerror = 1;
      // }
      if (vaerror == 1) {
        setTimeout(() => {
          self.PreLoader = false;
        }, 500);
        return;
      } else {
        // const key = await this.generateAESGCMKey ();
        const key = this.$sunidhi.keyValue;

        const userPlainText = this.username;
        const pwdPlainText = this.password;

        const userEncryptedText = await this.$sunidhi.encryptValue(
          userPlainText,
          key
        );
        const pwdEncryptedText = await this.$sunidhi.encryptValue(
          pwdPlainText,
          key
        );

        var objectUser = new Object();
        objectUser.username = userEncryptedText;
        objectUser.password = pwdEncryptedText;
        objectUser.key = key;
        objectUser.tag = userEncryptedText.tag;
        objectUser.nonce = userEncryptedText.iv;

        try {
          const response = await axios.post(
            // externalURL + "DSALoginAuthentication/",
            externalURL + "DSALoginAuthentication_check/",
            null,
            {
              type: "POST",
              headers: {
                Username: objectUser.username,
                Password: objectUser.password,
                Pwausertype: "DSA",
              },
              responseType: "json",
            }
          );
          console.log("Login =>", response);

          const data = response.data;

        

          if (data) {
            if (data.DSAAuthenticationStatus == "01") {
              self.dsaLoginErrorMsg = data.message;
              setTimeout(() => {
                self.PreLoader = false;
              }, 500);
              document.getElementById("loginModal").style.display = "";
              self.isModalpopUp = true;
              self.errorPopup = true;
              self.changePasswordPopup = false;
            } else if (data.DSAAuthenticationStatus !== "01") {
              setSessionId(data.PWAUserSessionId);
              const DSAUserIDDecrypted = await this.$sunidhi.decryptValue(
                data.DSAUserId,
                this.$sunidhi.keyValue
              );
              console.log("Login page response user id decryption:", DSAUserIDDecrypted)
              this.$sunidhi.decryptedDSAUserID = DSAUserIDDecrypted;
              DSAUserIDDecrypted.trimEnd();
              const DSAUserIDEncrypted = await this.$sunidhi.encryptValue(
                DSAUserIDDecrypted,
                this.$sunidhi.keyValue
              );
              DSAUserIDEncrypted.trimEnd();

              switch (data.DSAAuthenticationStatus) {
                case "00": // Success (1st time login) -> then go to change pwd page
                  if (data.DSAPasswordChangeFlag != null) {
                    if (data.DSAPasswordChangeFlag == "CHANGEPASSWORD") {
                      var genzdata = await db.TbGenz.where("UserId")
                        .anyOf(1)
                        .toArray();
                      if (genzdata != null && genzdata.length > 0) {
                        await db.TbGenz.update(genzdata[0].PkId, {
                          LoginUserID: objectUser.username,
                          DSALoginPwd: objectUser.password,
                          loginType: data.LoginType,
                          DSAUserId: DSAUserIDEncrypted,
                          DSAPasswordChangeFlag: data.DSAPasswordChangeFlag,
                          PWAUserSessionStatus: data.PWAUserSessionStatus,
                          PWAUserBranchCode: data.PWAUserBranchCode,
                          PWAUserBranchName: data.PWAUserBranchName,
                          // PWAUserSessionId: data.PWAUserSessionId,
                        });
                      } else {
                        await db.TbGenz.put({
                          UserId: 1,
                          LoginUserID: objectUser.username,
                          DSALoginPwd: objectUser.password,
                          loginType: data.LoginType,
                          DSAUserId: DSAUserIDEncrypted,
                          DSAPasswordChangeFlag: data.DSAPasswordChangeFlag,
                          PWAUserSessionStatus: data.PWAUserSessionStatus,
                          PWAUserBranchCode: data.PWAUserBranchCode,
                          PWAUserBranchName: data.PWAUserBranchName,
                          // PWAUserSessionId: data.PWAUserSessionId,
                        });
                        genzdata = await db.TbGenz.where("UserId")
                          .anyOf(1)
                          .toArray();
                      }
                      setTimeout(() => {
                        self.PreLoader = false;
                      }, 500);
                      document.getElementById("loginModal").style.display = "";
                      self.errorPopup = false;
                      self.isModalpopUp = true;
                      // self.changePasswordPopup = true;
                      self.changePasswordPopup = true;
                    }
                  }
                  break;

                case "76": // success (Existing DSA User who has changed the password previously)
                  if (data.DSAPasswordChangeFlag == "KEEPPASSWORD") {
              
                    var genzdata1 = await db.TbGenz.where("UserId")
                      .anyOf(1)
                      .toArray();
                    if (genzdata1 != null && genzdata1.length > 0) {
                      await db.TbGenz.update(genzdata1[0].PkId, {
                        LoginUserID: objectUser.username,
                        DSALoginPwd: objectUser.password,
                        loginType: data.LoginType,
                        DSAUserId: DSAUserIDEncrypted,
                        DSAPasswordChangeFlag: data.DSAPasswordChangeFlag,
                        PWAUserSessionStatus: data.PWAUserSessionStatus,
                        PWAUserBranchCode: data.PWAUserBranchCode,
                        PWAUserBranchName: data.PWAUserBranchName,
                        PWAUserSessionId: data.PWAUserSessionId,
                      });
                    } else {
                      await db.TbGenz.put({
                        UserId: 1,
                        LoginUserID: objectUser.username,
                        DSALoginPwd: objectUser.password,
                        loginType: data.LoginType,
                        DSAUserId: DSAUserIDEncrypted,
                        DSAPasswordChangeFlag: data.DSAPasswordChangeFlag,
                        PWAUserSessionStatus: data.PWAUserSessionStatus,
                        PWAUserBranchCode: data.PWAUserBranchCode,
                        PWAUserBranchName: data.PWAUserBranchName,
                        PWAUserSessionId: data.PWAUserSessionId,
                      });
                      genzdata = await db.TbGenz.where("UserId")
                        .anyOf(1)
                        .toArray();
                    }
                    setTimeout(() => {
                      self.PreLoader = false;
                    }, 500);
                    document.getElementById("loginModal").style.display = "";
                    self.isModalpopUp = false;
                    self.changePasswordPopup = false;
                    // setLogoutBtnDisp('false');
                    this.$sunidhi.logoutBtnDisp = false;
                    router.push({ name: "otpPage" });
                  }
                  break;

                // case "81": // duplicate session
                //    setTimeout(() => {
                //                 self.PreLoader = false;
                //             }, 500);
                //             this.$sunidhi.logoutBtnDisp = false;
                //             router.push({ name: 'SessionTimeout' });

                //   break;        
                case "100":
                  //   self.dsaLoginErrorMsg = "Invalid Credentials";
                  self.dsaLoginErrorMsg = data.DSAAuthenticationStatusMessage;
                  setTimeout(() => {
                    self.PreLoader = false;
                  }, 500);
                  document.getElementById("loginModal").style.display = "";
                  self.isModalpopUp = true;
                  self.errorPopup = true;
                  self.changePasswordPopup = false;
                  break;
                case "101":
                  self.dsaLoginErrorMsg = "Invalid Credentials";
                  setTimeout(() => {
                    self.PreLoader = false;
                  }, 500);
                  document.getElementById("loginModal").style.display = "";
                  self.isModalpopUp = true;
                  self.errorPopup = true;
                  self.changePasswordPopup = false;
                  break;
                case "102":
                case "61": // Inactive User
                case "62":
                case "63": // Error
                  // falls through

                
                default:
                  self.dsaLoginErrorMsg =
                    data.DSAAuthenticationStatusMessage ||
                    "Something went wrong. Please try again later.";
                  setTimeout(() => {
                    self.PreLoader = false;
                  }, 500);
                  document.getElementById("loginModal").style.display = "";
                  self.isModalpopUp = true;
                  self.errorPopup = true;
                  self.changePasswordPopup = false;
                  break;
              }
            }
          } else {
            setTimeout(() => {
              self.PreLoader = false;
            }, 1000);
            alert(this.$sunidhi.sessionIdErrorMsg);
        
          }
        } catch (error) {
          console.log("Error = >", error)
          if(error.message === 'Duplicate session'){
             setTimeout(() => {
            self.PreLoader = false;
          }, 1000);
            return;
          } else if(error.message === 'AxiosError'){
            alert(
            "We’re unable to connect to the server right now. " +
            "Please check your internet connection and try again."
          );
           setTimeout(() => {
            self.PreLoader = false;
          }, 1000);
          return;
          }

          setTimeout(() => {
            self.PreLoader = false;
          }, 1000);
          console.log("DSALoginAuthError =>", error.name);
          alert(this.$sunidhi.exceptionalNetworkError);
          // if (error.code === "ERR_NETWORK") {
          //   alert(this.$sunidhi.exceptionalNetworkError);
          // } else {
          //   alert(this.$sunidhi.exceptionalGeneralError);
          // }
          self.isModalpopUp = false;
          self.changePasswordPopup = false;
          self.errorPopup = true;
        }
      }
    },

    async ContinueToChangePwd() {
      this.$sunidhi.logoutBtnDisp = false;
      router.push({ name: "ChangePasswordPage" });
    },
    async returnToLoginPage() {
      document.getElementById("loginModal").style.display = "none";
    },

    async generateAESGCMKey() {
      const key = await window.crypto.subtle.generateKey(
        {
          name: "AES-GCM",
          length: 128, // 256-bit key length
        },
        true, // Extractable
        ["encrypt", "decrypt"]
      ); // Key usages);
      const encodedKey = btoa(
        String.fromCharCode(
          ...new Uint8Array(await window.crypto.subtle.exportKey("raw", key))
        )
      );
      // The btoa function encodes the raw key data into base64
      return encodedKey;
    },

    async encryptText(plainText) {
      // const keyBuffer = Uint8Array.from(atob(base64Key), c => c.charCodeAt(0));

      const cryptoKey = await window.crypto.subtle.generateKey(
        { name: "AES-GCM", length: 128 },
        true,
        ["encrypt", "decrypt"]
      );

      //   const cryptoKey = await window.crypto.subtle.importKey ("raw", keyBuffer, { name: "AES-GCM" }, false, ["encrypt", "decrypt"]);

      // Generate a random initialization vector (IV)
      const iv = window.crypto.getRandomValues(new Uint8Array(12));
      // Encrypt the plain text
      const plainTextBuffer = new TextEncoder().encode(plainText);
      const encryptedBuffer = await window.crypto.subtle.encrypt(
        { name: "AES-GCM", iv },
        cryptoKey,
        plainTextBuffer
      );
      //   const nonce = encryptedBuffer.slice(0, 12);
      // Combine the IV and encrypted buffer for decryption later
      const resultBuffer = new Uint8Array(12 + encryptedBuffer.byteLength);

      const tag = new Uint8Array(
        encryptedBuffer.slice(
          encryptedBuffer.byteLength - 16,
          encryptedBuffer.byteLength
        )
      );

      resultBuffer.set(iv);
      resultBuffer.set(new Uint8Array(encryptedBuffer), 12);
      // Convert the result to a base64 string
      const resultBase64 = btoa(String.fromCharCode(...resultBuffer));
      const encryptedTextData = {
        resultBase64: resultBase64,
        iv: iv,
        tag: tag,
      };

      return encryptedTextData;
    },
  },
};
</script>

<style lang="css" scoped>
/* .LogoutStyle{
  float: right;
  display: none !important;
} */
.inputStyle {
  width: 70%;
  border-radius: 5px;
  height: 5vh;
  border: 2px solid #00000045;
}
.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 1px !important;
}
.LabelStyle {
  margin-bottom: 7px;
  font-family: "Arial";
  text-align: left;
  font-weight: bold;
  font-size: 15px !important;
}
.preLoginHeaderstyle {
  text-align: center !important;
  font-size: 30px !important;
  /* padding-top: 70px !important; */
}
.v-content__wrap {
  width: 100%;
  position: relative;
}
.v-content {
  transition: none;
  display: flex;
  flex: 1 0 auto;
  width: 100%;
  max-width: 100%;
  justify-content: center;
}
.container1 {
  /* background: #0000ff36; */
  display: flex;
  margin-top: 60px;
  align-items: center;
  justify-content: center;
}

.col-lg-6 {
  padding: 20px;
  width: 98%;
  justify-content: center;
  text-align: center;
  border-radius: 15px;
}
.login-left-img {
  /* width: 100%; */
  width: 93%;
  border-radius: 15px;
  /* height: 80% !important;
                width: 80% !important; */
}
.login-logo-img {
  width: 100px;
  text-align: center;
  justify-content: center;
}

/* Create two equal columns that floats next to each other */
.resendOtp {
  border: none;
  box-shadow: none !important;
  margin-top: -10px !important;
  float: right;
  color: #938e8e !important;
  background-color: transparent !important;
}
.activeLink {
  color: #e3352a !important;
}
.activeLink:hover {
  text-decoration-line: underline;
}
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  /* inset: auto !important; */
}

.modal {
  background: #ffffff;
  box-shadow: 0px 0px 4px 1px;
  overflow-x: auto;
  display: flex;
  flex-direction: column;
  width: 50%;
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  position: relative;
  border-bottom: 1px solid #eeeeee;
  color: #4aae9b;
  justify-content: space-between;
}

.modal-footer {
  border-top: 1px solid #eeeeee;
  flex-direction: column;
  justify-content: flex-end;
}

.modal-body {
  position: relative;
  padding: 20px 10px;
}

.btn-close {
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  font-size: 20px;
  padding: 10px;
  cursor: pointer;
  font-weight: bold;
  color: #4aae9b;
  background: transparent;
}

.btn-green {
  color: white;
  background: #4aae9b;
  border: 1px solid #4aae9b;
  border-radius: 2px;
}

.flex-container {
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;
}

#LoginImg {
  flex: 1;
}

#LoginField {
  /* flex:1 */
  width: 100%;
}

#Img {
  /* flex-grow: 0 0; */
  width: 100%;
  text-align: center;
  flex-grow: 0;
}
#TextField {
  width: 100%;
  flex-grow: 1;
  border: 2px solid #808080bf;
  padding: 20px;
}

.v-input__slot {
  border-radius: 15px !important;
}

.row {
  display: flex;
  padding: 10px;
  width: 75%;
  align-items: center;
  /* background-color: #d3d3d373; */
  background-color: white;
  flex-direction: row;
  border-radius: 15px;
  /* gap: 1rem; */
  max-width: fit-content;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.container {
  /* background: #f2f2f2; */
  display: flex;
  justify-content: center !important;
  align-items: center !important;
  height: auto !important;
  /* margin-top: 28px !important; */
  margin-top: 5px !important;
}

.login {
  width: 800px;
  min-height: 400px;
  overflow: hidden;
  border-radius: 15px;
  /* background: #222; */
  background: #bdbdbd;
  display: flex;
  box-shadow: 15px 5px 30px rgba(0, 0, 0, 0, 3);
}
.container.fill-height {
  place-content: center !important;
}

.content {
  flex-basis: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  /* background: #FF8200; */
  background: white;
  /* background: rgb(255 130 0 / 83%); */
}

.content img {
  width: 100%;
}

.loginForm {
  flex-basis: 50%;
  background: white;
  font-family: Arial;
  padding: 0 25px 25px 25px;
}
.loginForm h1 {
  text-align: center !important;
  margin-top: 25px !important;
  font-size: 2.5em !important;
  margin-bottom: 10px !important;
  /* color: #fff !important; */
}
.tbox {
  border-radius: 3px;
  background: transparent;
  outline: none;
  /* border: 1px solid #55efc4; */
  width: 100%;
  height: 35px;
  margin: 30px 0;
}

.tbox .v-text-field {
  background: transparent;
  width: 90%;
  outline: none;
  border: 0;
  padding-left: 7px;
}

.LogoutDisp {
  display: none !important;
}

.LogoutStyle {
  display: none !important;
}

.containerStyle {
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
  transform: translate(-50%, -50%) !important;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
  display: none !important;
}

/* Forgot Pwd CSS START */
.UNStyle,
.v-input__slot {
  border-radius: 5px !important;
}

/* Forgot Pwd CSS END */

@media screen and (max-width: 280px) {
  .content {
    display: none !important;
  }
  .login {
    flex-direction: row !important;
  }
}

@media screen and (max-width: 300px) {
  .content {
    display: none !important;
  }
  .login {
    flex-direction: row !important;
  }
}
@media screen and (max-width: 475px) {
  .content {
    display: none !important;
  }
  .login {
    flex-direction: row !important;
  }
}

@media screen and (max-width: 600px) {
  .login {
    flex-direction: column !important;
    margin: 0 15px !important;
  }
}

@media screen and (min-width: 992px) {
  .login {
    flex-direction: row !important;
    margin: 0 15px !important;
  }
}

@media (min-width: 960px) {
  .flex.md6 {
    flex-basis: 100% !important;
    max-width: 100% !important;
  }
}

/* 
  @media screen and (min-width:1024px) {

    .login {
        flex-direction: row !important;
        margin: 0 15px !important;
    }
  }  */
@media screen and (min-width: 1280px) {
  .row {
    /* width: 100% !important; */
    flex-direction: row !important;
  }
  #Img {
    display: flex !important;
  }
}
@media screen and (min-width: 1536px) {
  .row {
    /* width: 100% !important; */
    flex-direction: row !important;
  }
  #Img {
    display: flex !important;
  }
}

/* @media screen and (max-width:992px) {
    .row{
        width: 100% !important;
        flex-direction: column !important;
    }
  }
  @media screen and (max-width:1200px) {
    
  }
  @media screen and (max-width:1400px) {
    
  }
  @media screen and (max-width:1600px) {
    
  }
  @media screen and (max-width:1900px) {
    
  }
  
  

  /* @media screen and (max-width: 425px) {
    .row {
        width: 100%;
        flex-direction: column;
    }
    .col-lg-6 {
        width: 100%;
    }
    .login-left-img {
        display: none;
    }
    
  }
  @media screen and (max-width: 768px) {
    .row {
    }
    .login-left-img {
        width: 320px !important;
        border-radius: 15px;
    }
    
  }
  @media screen and (min-width: 1024px) {

  }

  @media only screen and (max-width: 959px) {
            #createAccount{
                padding-top: 0px !important;
                text-align: center !important;

            }} */
</style>
